module.exports = __webpack_public_path__ + "img/9.ac629023.png";